/***************************************************************
5/27/2017
Alexander Self
Timesheet modal
- Summary of individual timesheet to be submitted; used as a check prior to
  submitting timesheets
***************************************************************/
import TimesheetEmployeeTable from './timesheet_modal_emp_table';
import TimesheetWorkTable from './timesheet_modal_work_table';
import { totalHours } from '../../../utils';
import React from 'react';
const $ = window.$;

const TimesheetIndividualModal = ({ id, timesheet, employees, workPerformed, submitRegTimesheet, payPeriodStartDate, payPeriodEndDate,
  prevPPStartDate, prevPPEndDate, user }) => {
  if (!timesheet.startTime || !timesheet.endTime) {
    timesheet.startTime = '';
    timesheet.endTime = '';
  }
  let tsCheck = '';
  let work = totalHours(workPerformed);
  /* Let users know they have not selected any employees */
  if (employees.length === 0) tsCheck = 'No employees selected';
  $(document).ready(() => {
    $(`#${id}`).modal();
  });
  return (
    <div id={id} className="modal modal-fixed-footer">
      <div className="modal-content">
        <h4>Timesheet Summary</h4> <hr />
        { work > 12 ? <h4 className="day-off">Total hours are: {work}. Is this correct?</h4> : '' }
        { work < 8 ? <h4 className="day-off">Total working hours are: {work}. Is this correct?</h4> : '' }
        <p>{tsCheck}</p>
        <blockquote>
          <div className="row">
            <div className="col s12 m12 l12">
              <ul className="collection flow-text">
                <li className="collection-item">Date: <b><span className="right">{ timesheet.date }</span></b></li>
                <li className="collection-item">Location: <b><span className="right">{ timesheet.location }</span></b></li>
                <li className="collection-item">Start Time: <b><span className="right">{ timesheet.startTime ? timesheet.startTime : '' }</span></b></li>
                <li className="collection-item">End Time: <b><span className="right">{ timesheet.endTime ? timesheet.endTime : '' }</span></b></li>
                <li className="collection-item">Gang No: <b><span className="right">{ timesheet.gang ? timesheet.gang : '' }</span></b></li>
              </ul>
            </div>
          </div>
        </blockquote>
        <div className="row">
          <TimesheetEmployeeTable timesheet={timesheet} employees={employees} />
        </div>
        <hr />
        <div className="row">
          { workPerformed.length > 0 ? <TimesheetWorkTable workPerformed={workPerformed} /> : '' }
        </div>
      </div>
      <div className="modal-footer">
        <button type="button" className="modal-action modal-close waves-effect waves-red btn-flat">Cancel</button>
        <button type="button" onClick={() => submitRegTimesheet(employees, timesheet, { payPeriodStartDate, payPeriodEndDate, prevPPStartDate, prevPPEndDate }, user)} id="reg-ts-btn"
          className="modal-action modal-close waves-effect waves-green btn-flat">
          Submit
        </button>
      </div>
    </div>
  );
};

export default TimesheetIndividualModal;



// WEBPACK FOOTER //
// ./src/components/timesheets/create/timesheet_individual_modal.js